module.exports = __webpack_public_path__ + "static/media/night8.e440fd5f.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/night8.jpeg
// module id = 30
// module chunks = 0